import Overview from './overview.vue';
import Full from '@rebuild/materials/shared/custom/Full.vue';

export const componentMap = {
	overview: Overview,
	full: Full
};
